import {useMutation} from "@tanstack/react-query";

import {addLeadContactMutationOptions} from "./add-lead-contact.mutation-options";

export function useAddLeadContact(leadId: string) {
  return useMutation(addLeadContactMutationOptions(leadId));
}
